export const UpdatePinOnMainPlan = (
  mainPlan,
  pin,
  item
) => {
  const newPlanData = JSON.parse(JSON.stringify(mainPlan)); // mutation is Scary  8)

  const newMainPlan = newPlanData.polygons.map(poly => {
    if (poly.subPlan.uid === pin.uid) { // find polygon which has The pin
      poly.subPlan.pins.forEach(p => {
        if (p.packetId === pin.packetId) { // find The pin
          p[item] = pin[item];
        }
      });
    };
    return poly;
  });
  newPlanData.polygons = newMainPlan;

  return newPlanData;
};

export const UpdatePinOnMainPlanCreatePolygon = (
  mainPlan,
  pin
) => {
  const newPlanData = JSON.parse(JSON.stringify(mainPlan)); // mutation is Scary  8)

  const newMainPlan = newPlanData.polygons.map(poly => {
    if (poly.subPlan.uid === pin.uid) { // find polygon which has The pin
      poly.subPlan.pins.forEach(p => {
        if (p.packetId === pin.packetId) { // find The pin
          p["newPolygon"] = !pin["newPolygon"];
          p["isChanged"] = !pin["isChanged"];
        }
      });
    };
    return poly;
  });
  newPlanData.polygons = newMainPlan;

  return newPlanData;
};